import { db } from '../firebase/firebase'
import { FETCH_SUBSCRIPTIONS, FETCH_MYSUBSCRIPTIONS, SUBSCRIBE_TO_TOPIC } from '../constants/actionTypes'
import _ from 'lodash'

export const fetchSubscriptions = (dispatch)=> {
    
    const subscriptionList = []
    db.ref('/topics').once('value', snapshot =>{
        _.map(snapshot.val(), (topic, key)=>{
            const subscription = {
                subType: key,
                name: topic.name
            }
            subscriptionList.push(subscription)
        })
    })
    .then(()=>dispatch(
        {
            type: FETCH_SUBSCRIPTIONS,
            payload: subscriptionList
        }
    ))
}

export const fetchMySubscriptions = (dispatch, userId) => {
    const mySubscriptionList = []
    db.ref('/mySubscriptions').child(userId).once('value', snapshot =>{
            if(snapshot.exists())
            mySubscriptionList.push(...snapshot.val().mySubscriptions.split(','))
    })
    .then(()=>dispatch(
        {
            type: FETCH_MYSUBSCRIPTIONS,
            payload: mySubscriptionList
        }
    ))
}

export const subscribeToTopic = (dispatch, updatedMySubscriptionState) => {
    const { isMyTopic, userId, newMySubscriptions, topic, token } = updatedMySubscriptionState
    const refMySubscriptions = db.ref('/mySubscriptions')
    const refTopics = db.ref(`/topics/${topic}`)
   
    const newMySubscriptionsString = newMySubscriptions.toString()
    // in case isMyTopic is true it will be removed form subscriptionos/{userId}/mySubscritions = array
    // topic will be removed
    if(!isMyTopic){
     refMySubscriptions.child(userId).set({mySubscriptions: newMySubscriptionsString})
     refTopics.child(userId).set({token: token})
     
    } else { // in case isn't my it will become my topic
         // case myNewSubscriptin array is empty (=last subscription was removed)
        if(newMySubscriptions.length === 0) {
            refMySubscriptions.child(userId).remove()
        } else { 
            //case isn't last subscriptions push newMySubscritption STRING  to firebase subscriptions/mySubscription
            refMySubscriptions.child(userId).set({mySubscriptions: newMySubscriptionsString}) 
        }
        //remove user from notfification Topic
        refTopics.child(userId).remove()        
    }
    // dispatch newSubscriptions to Redux
    dispatch({type: SUBSCRIBE_TO_TOPIC, payload: newMySubscriptions})
}

    



// WEBPACK FOOTER //
// ./src/actions/subscriptions.js